import { Box, Divider, IconButton, Link } from "@mui/material";
import { MobileViewCellDataGrid } from "components/MobileViewCellDataGrid/MobileViewCellDataGrid";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { TimeLeft } from "components/DateTime/TimeLeft";
import { ContextMenu } from "components/Menu/ContextMenu";
import { TimeSince } from "components/DateTime/TimeSince";

export const projectListColumnsS = ({
  handleRowClick,
  handleTaskButtonClick,
  handleOpenProducts,
  handleEdit,
  currentUserId,
}) => [
  {
    accessorKey: "clientName",
    header: "Details",
    cell: ({ row }) => (
      <>
        <MobileViewCellDataGrid
          tableData={[
            {
              label: "Code",
              data: (
                <FlexBox justifyContent="space-between">
                  <Link
                    href="#"
                    onClick={() => handleRowClick(row.original)}
                    color="textPrimary"
                  >
                    {row.original.docCode}
                  </Link>
                </FlexBox>
              ),
              action: "",
            },
            {
              label: "Name",
              data: (
                <FlexBox justifyContent="space-between">
                  <Link
                    href="#"
                    onClick={() => handleRowClick(row.original)}
                    color="textPrimary"
                  >
                    {row.original.clientName}
                  </Link>
                </FlexBox>
              ),
              action: "",
            },
            {
              label: "BDC",
              data: (
                <Box whiteSpace={"pre-line"}>
                  {row.original.createdBy}
                  <br />
                  <TimeSince startDate={row.original.createdOn} />
                </Box>
              ),
              action: "",
            },
            {
              label: "Delivery Date",
              data: (
                <TimeLeft
                  targetDate={row.original.projectDeliveryDate}
                  variant="data"
                  fontSize={12}
                />
              ),
              action: "",
            },
            {
              label: "Products",
              data: (
                <IconButton onClick={() => handleOpenProducts(row.original)}>
                  <AddShoppingCartIcon />
                </IconButton>
              ),
              action: "",
            },
            {
              label: "Action",
              data: (
                <ContextMenu
                  handleEditAction={
                    currentUserId === row.original.createdById
                      ? () => handleEdit(row.original)
                      : null
                  }
                  editLabel="Update Delivery Date"
                  handleTaskAction={() => handleTaskButtonClick(row.original)}
                  taskLabel="Create Task"
                />
              ),
              action: "",
            },
          ]}
        />
        <Divider />
      </>
    ),
  },
];
